<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { h } from 'vue';
import { useVueTable, getCoreRowModel } from '@tanstack/vue-table';
import Table from 'dashboard/components/table/Table.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { money } from './model';
const props = defineProps({
  rows: { type: Array, default: () => [] },
  currency: { type: String, default: 'RUB' },
});
const emit = defineEmits(['select']);
const members = r =>
  `${r.member_count ?? 'Нет данных'}${r.stale ? ' · устарело' : ''}`;
const columns = [
  {
    id: 'title',
    size: 340,
    header: 'Группа',
    cell: ({ row }) =>
      h(Button, {
        label: row.original.title,
        slate: true,
        ghost: true,
        class:
          'max-w-full w-full min-w-0 text-left [&>span]:whitespace-normal [&>span]:break-words',
        onClick: () => emit('select', row.original.id),
      }),
  },
  {
    id: 'members',
    header: 'Участники',
    cell: ({ row }) => members(row.original),
  },
  {
    id: 'delta',
    header: 'Изменение',
    cell: ({ row }) => row.original.member_delta ?? 'Нет истории',
  },
  ...[
    ['income_minor', 'Приходы'],
    ['expense_minor', 'Расходы'],
    ['result_minor', 'Результат'],
  ].map(([key, header]) => ({
    id: key,
    header,
    cell: ({ row }) => money(row.original[key], props.currency),
  })),
];
const table = useVueTable({
  get data() {
    return props.rows;
  },
  columns,
  getCoreRowModel: getCoreRowModel(),
  enableSorting: false,
});
</script>

<template>
  <div class="hidden lg:block overflow-x-auto">
    <Table :table="table" fixed type="compact" class="min-w-[800px] w-full" />
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:hidden gap-3">
    <article
      v-for="row in rows"
      :key="row.id"
      class="border border-n-weak rounded-xl p-4 min-w-0 flex flex-col gap-2"
    >
      <Button
        :label="row.title"
        slate
        ghost
        class="max-w-full w-full min-w-0 text-left justify-start [&>span]:whitespace-normal [&>span]:break-words"
        @click="emit('select', row.id)"
      />
      <p class="text-sm text-n-slate-11 m-0">
        Участники: {{ members(row) }} · Изменение:
        {{ row.member_delta ?? 'нет истории' }}
      </p>
      <p class="text-sm text-n-slate-12 m-0">
        Приходы: {{ money(row.income_minor, currency) }}
      </p>
      <p class="text-sm text-n-slate-12 m-0">
        Расходы: {{ money(row.expense_minor, currency) }}
      </p>
      <p class="text-sm text-n-slate-12 m-0">
        Результат: {{ money(row.result_minor, currency) }}
      </p>
    </article>
  </div>
</template>
